import { createFileRoute } from '@tanstack/react-router';

import { AdminImagesPage } from '@/components/admin/images-page';
import { adminHead } from '@/lib/seo';
import { adminListImagesFn } from '@/server/functions/admin';

export const Route = createFileRoute('/_admin/admin/images')({
    component: ImagesRoute,
    head: () => adminHead('תמונות', '/admin/images'),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: () => adminListImagesFn({ data: { limit: 50 } }),
});

function ImagesRoute() {
    const data = Route.useLoaderData();
    return <AdminImagesPage initial={data} />;
}
